import { getTransitionBonusAction } from 'automaton/actions/TransitionBonusAction'
import { getBetState } from 'automaton/states/BetState'
import { getFreeBetState } from 'automaton/states/FreeBetState'
import { getFreespinAddState } from 'automaton/states/FreespinsAddState'
import { getFreespinEndState } from 'automaton/states/FreespinsEndState'
import { getFreespinsSpinState } from 'automaton/states/FreespinsSpinState'

export function getTransitionState() {
  const freespinModel = game.models.FreespinModel.get()
  const freeBetModel = game.models.FreebetsModel.get()
  const spinModel = game.models.SpinModel.get()
  const currentAction = spinModel.current
  const checkWorld = (currentAction) => {
    return  currentAction.includes('freespin')
  }
  const isFs = checkWorld(currentAction)
  const name = 'Transition'
  const actions = [getTransitionBonusAction()]
  const transition = () => freespinModel.left ? freespinModel.left === freespinModel.all ? getFreespinAddState(false) : freespinModel.add ? getFreespinAddState(true) : getFreespinsSpinState() : freespinModel.left === 0 && isFs ? getFreespinEndState()  : freeBetModel.rest ? getFreeBetState() : getBetState()

  return {
    name,
    actions,
    transition,
  }
}
